import axios from 'axios';
import Constants from '../constants';
import { IDistributionHierarchy } from '../models/IDistributionHierarchy';

export function getDistributionHierarchyQuery(surveyId: number, audienceId: number) {
	const query =
		Constants.AUDIENCE_API_BASE_URL.replace('{surveyId}', surveyId.toString()).replace('{audienceId}', audienceId.toString()) +
		'/distribution-hierarchy';

	return query;
}

export async function getDistributionHierarchy(surveyId: number, audienceId: number): Promise<IDistributionHierarchy> {
	const res = await axios.get(getDistributionHierarchyQuery(surveyId, audienceId));
	return res.data;
}

export async function createDistributionHierarchy(
	surveyId: number,
	audienceId: number,
	distributionHierarchy: IDistributionHierarchy,
): Promise<IDistributionHierarchy> {
	const res = await axios.post(getDistributionHierarchyQuery(surveyId, audienceId), distributionHierarchy);
	return res.data;
}

export async function updateDistributionHierarchy(
	surveyId: number,
	audienceId: number,
	distributionHierarchy: IDistributionHierarchy,
): Promise<IDistributionHierarchy> {
	const res = await axios.put(getDistributionHierarchyQuery(surveyId, audienceId), distributionHierarchy);
	return res.data;
}

export async function getHierarchyDownloadForAccessCodes(
	surveyId: number,
	audienceId: number,
	distributionHierarchy: IDistributionHierarchy,
) {
	const query = getDistributionHierarchyQuery(surveyId, audienceId) + '/access-codes';
	const res = await axios.post(query, distributionHierarchy, {
		responseType: Constants.FileDownloadResponseType,
		timeout: Constants.FileDownloadTimeout,
		headers: Constants.excelResponseHeader,
	});
	return res.data;
}

export async function uploadHierarchyDownloadForAccessCodes(surveyId: number, audienceId: number, file: File) {
	const data = new FormData();
	data.append('file', file);
	const res = await axios.post(getDistributionHierarchyQuery(surveyId, audienceId) + '/access-codes/upload', data);
	return res.data;
}

export async function validateHierarchyCustomAccessCodes(
	surveyId: number,
	audienceId: number,
	distributionHierarchy: IDistributionHierarchy,
) {
	const query = getDistributionHierarchyQuery(surveyId, audienceId) + '/access-codes/validate-audience';
	const res = await axios.post(query, distributionHierarchy);
	return res.data;
}
